/**
 * Staging-safe store cache clear for Telegram WebView.
 * Clears local UI caches only — never touches D1 orders.
 */

const STORE_CACHE_KEYS = [
  "asiastyle.miniapp.promo_code",
  "asiastyle.miniapp.catalog_filter",
  "asiastyle.miniapp.catalog_search",
  "asiastyle.miniapp.local_cart_cache",
  "asiastyle.crm.local_cart",
];

export function clearMiniAppStoreUiCache(): { cleared: string[] } {
  const cleared: string[] = [];
  try {
    for (const key of STORE_CACHE_KEYS) {
      if (sessionStorage.getItem(key) != null) {
        sessionStorage.removeItem(key);
        cleared.push(`session:${key}`);
      }
      if (localStorage.getItem(key) != null) {
        localStorage.removeItem(key);
        cleared.push(`local:${key}`);
      }
    }
    // Sweep any asiastyle.* UI keys (not secrets).
    for (const store of [sessionStorage, localStorage]) {
      const keys: string[] = [];
      for (let i = 0; i < store.length; i++) {
        const k = store.key(i);
        if (k && k.startsWith("asiastyle.") && !k.toLowerCase().includes("token")) {
          keys.push(k);
        }
      }
      for (const k of keys) {
        store.removeItem(k);
        cleared.push(k);
      }
    }
  } catch {
    /* ignore quota / private mode */
  }
  return { cleared: [...new Set(cleared)] };
}
